import * as TyreRepairOrderModels from '../../models/tyre-repair-order/tyre-repair-order';
import { TyreRepairOrderSearchModel } from '../../models/tyre-repair-order/tyre-repair-orderSearch';
import * as Models from '../../models/commonModels';

export class GetList {
  static readonly type = '[TyreRepairOrder] List';
  constructor(public Search: TyreRepairOrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[TyreRepairOrder] Set Search';
  constructor(public Search: TyreRepairOrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[TyreRepairOrder] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[TyreRepairOrder] Set List Page';
  constructor(public Search: TyreRepairOrderSearchModel) { }
}

export class Set {
  static readonly type = '[TyreRepairOrder] Set';
  constructor(public Order: Models.Request<TyreRepairOrderModels.TyreRepairOrderModel>) { }
}

export class Get {
  static readonly type = '[TyreRepairOrder] Get';
  constructor(public OrderId: Models.RequestModel) { }
}


export class GetStatusDictionary {
  static readonly type = '[TyreRepairOrder] Get Status Dictionary';
  constructor() { }
}

export class DisposeSearch {
  static readonly type = '[TyreRepairOrder] DisposeSearch';
  constructor() { }
}

export class Create {
  static readonly type = '[TyreRepairOrder] Create';
  constructor(public Order: Models.RequestNewOrder<TyreRepairOrderModels.TyreRepairOrderModel>) { }
}
